import React from 'react';
import { Button, Stack } from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';

const { OutlinedCheckCircleIcon, OutlinedTrashIcon } = OutlinedIcons;

type SuggestionFieldActionsProps = {
  onApply: () => void;
  onDismiss: () => void;
  disabled?: boolean;
};

const SuggestionFieldActions = ({
  onApply,
  onDismiss,
  disabled = false,
}: SuggestionFieldActionsProps) => (
  <Stack direction="row" spacing={2} alignItems="center">
    <Button
      size="small"
      variant="text"
      onClick={onApply}
      disabled={disabled}
      startIcon={<OutlinedCheckCircleIcon fontSize="small" sx={{ color: 'success.main' }} />}
      sx={{
        px: 1,
        py: 0.5,
        minWidth: 0,
        typography: 'captionBold',
        color: 'text.primary',
      }}
    >
      Apply to Profile
    </Button>
    <Button
      size="small"
      variant="text"
      onClick={onDismiss}
      disabled={disabled}
      startIcon={<OutlinedTrashIcon fontSize="small" sx={{ color: 'error.main' }} />}
      sx={{
        px: 1,
        py: 0.5,
        minWidth: 0,
        typography: 'captionBold',
        color: 'text.primary',
      }}
    >
      Skip
    </Button>
  </Stack>
);

export default SuggestionFieldActions;
